<div
  class="modal fade show d-block move-template-modal"
  tabindex="-1"
  *ngIf="isMoveModalOpen"
>
  <div class="modal-dialog modal-dialog-prev modal-xl modal-dialog-centered">
    <div class="modal-content">
      <div class="modal-header">
        <h5 class="modal-title d-flex flex-column">
          <strong>{{ modalTitle }}</strong>
          <!-- <span *ngIf="modalTitle" class="text-muted" style="font-size: 14px">{{
            modalTitle
          }}</span> -->
        </h5>
        <button type="button" class="close" (click)="closeModal()">
          <span>&times;</span>
        </button>
      </div>

      <div class="modal-body text-center">
        <div class="mb-2">
          <input
            type="text"
            class="form-control"
            placeholder="Search journey or template..."
            [(ngModel)]="searchText"
            (input)="filterTree()"
          />
        </div>
        <ul *ngIf="filteredData?.length" class="tree">
          <li *ngFor="let parent of filteredData">
            <div
              [ngClass]="!parent.children?.length ? 'no-child' : ''"
              class="tree-row parent"
              (click)="parent.open = !parent.open"
            >
              <span *ngIf="parent.children?.length" class="arrow">
                <i *ngIf="parent.open" class="bi bi-chevron-down"></i>
                <i *ngIf="!parent.open" class="bi bi-chevron-right"></i>
              </span>

              <span>{{ parent.name }}</span>
            </div>

            <ul *ngIf="parent.children?.length && parent.open">
              <li *ngFor="let child of parent.children">
                <div class="tree-row child ms-4">
                  <input
                    type="checkbox"
                    [(ngModel)]="child.checked"
                    (change)="onChildCheck(child)"
                  />
                  <span>{{ child.name }}</span>
                </div>
              </li>
            </ul>
          </li>
        </ul>
        <div *ngIf="!filteredData.length" class="text-muted text-center py-3">
          No matching journeys or templates found.
        </div>
      </div>
      <div class="modal-footer">
        <button
          *ngIf="filteredData.length"
          class="btn btn-primary"
          (click)="submitMove()"
        >
          Move Templates
        </button>
      </div>
    </div>
  </div>
</div>

<!-- Backdrop -->
<div class="modal-backdrop fade show" *ngIf="isMoveModalOpen"></div>
